import { render } from "./MyBackupsWidget.vue?vue&type=template&id=75a44e5a&scoped=true"
import script from "./MyBackupsWidget.vue?vue&type=script&lang=js"
export * from "./MyBackupsWidget.vue?vue&type=script&lang=js"

import "./MyBackupsWidget.vue?vue&type=style&index=0&id=75a44e5a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a44e5a"]])

export default __exports__